import { EntityModel } from '@/interfaces'
import {
  ALL_IFRAME_BLOCKS_QUERY,
  CREATE_IFRAME_BLOCK_MUTATION,
  DELETE_IFRAME_BLOCK_MUTATION,
  FORCE_DELETE_IFRAME_BLOCK_MUTATION,
  SINGLE_IFRAME_BLOCK_QUERY,
  UPDATE_IFRAME_BLOCK_MUTATION,
} from './graphql'

const cmsIframeBlockModel: EntityModel = {
  name: 'iframeBlock',
  namePlural: 'iframeBlocks',
  uniqueName: 'cmsIframeBlock',
  uniqueNamePlural: 'cmsIframeBlocks',
  path: 'cms/blocks/iframe_block',
  baseUrl: '/cms/blocks/iframe_blocks',
  translationPrefix: 'entities:cmsIframeBlock.',
  getDisplayName: (values: any) => {
    return 'iFrame Block'
  },
  gql: {
    getAll: ALL_IFRAME_BLOCKS_QUERY,
    getSingle: SINGLE_IFRAME_BLOCK_QUERY,
    create: CREATE_IFRAME_BLOCK_MUTATION,
    update: UPDATE_IFRAME_BLOCK_MUTATION,
    delete: DELETE_IFRAME_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_IFRAME_BLOCK_MUTATION,
  },
  attributes: {
    url: {
      name: 'url',
      label: 'entities:cmsIframeBlock.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'url',
        },
      ],
    },
    minHeight: {
      name: 'minHeight',
      label: 'entities:cmsIframeBlock.attributes.minHeight.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'number',
        },
      ],
    },
  },
}

export default cmsIframeBlockModel
